import React, { useEffect } from "react";
import { motion } from "framer-motion";



import {
  FaFilePdf,
  FaArrowRight,
  FaPlayCircle,
} from "react-icons/fa";

import heroImg from "../assets/uploads/school.jpg";

/* =========================================================
   GENERAL INFORMATION
========================================================= */

const generalInfo = [
  {
    title: "Name of the School",
    value: "Cambridge International School",
  },
  {
    title: "Affiliation Number",
    value: "1631134",
  },
  {
    title: "School Code",
    value: "21124",
  },
  {
    title: "Complete Address",
    value: "Pandori Khas Road, Nakodar - 144040",
  },
  {
    title: "Principal Name",
    value: "Mrs. Sandhya Deewan",
  },
  {
    title: "Principal Qualification",
    value: "M.Sc (Chemistry), B.Ed (Phy, Bio)",
  },
  {
    title: "School Email",
    value: "cisnakodar@gmail.com",
  },
  {
    title: "Contact Number",
    value: "97813-00975",
  },
];

/* =========================================================
   DOCUMENTS
========================================================= */
const documents = [
  {
    title: "Affiliation / Upgradation Letter",
    link: "https://www.cisnakodar.in/uploads/AFFILIATIONLETTER.pdf",
  },
  {
    title: "Society / Trust Registration Certificate",
    link: "https://www.cisnakodar.in/uploads/TRUSTCERTIFICATE.pdf",
  },
  {
    title: "No Objection Certificate (NOC)",
    link: "https://www.cisnakodar.in/uploads/NOC.PDF",
  },
  {
    title: "Recognition Certificate under RTE Act",
    link: "https://www.cisnakodar.in/uploads/RECOGNITIONCERTIFICATE.PDF",
  },
  {
    title: "Building Safety Certificate",
    link: "/buildingsafety.pdf",
  },
  {
    title: "Fire Safety Certificate",
    link: "/firesafety.pdf",
  },
  {
    title: "DEO Certificate",
    link: "https://cisnakodar.in/uploads/DEOCERTIFICATE.PDF",
  },
  {
    title: "Water, Health & Sanitation Certificate",
    link: "/water.pdf",
  },
];
/* =========================================================
   ACADEMICS
========================================================= */

const academics = [
  {
    title: "Fee Structure of the School",
    link: "https://www.cisnakodar.in/uploads/FEESTRUCTURE.pdf",
  },
  {
  title: "Annual Academic Calendar",
  link: "/calendar.pdf",
},
  {
    title: "School Management Committee (SMC)",
    link: "https://cisnakodar.in/uploads/LIST_OF_SMC.pdf",
  },
  {
    title: "Parents Teachers Association (PTA)",
    link: "https://cisnakodar.in/uploads/LINKS_OF_PTA.pdf",
  },
  {
    title: "Last Three-Year Board Examination Results",
    link: "https://cisnakodar.in/uploads/LINK_OF_THREEYEARRESULTS.pdf",
  },
];

/* =========================================================
   STAFF
========================================================= */

const staff = [
  {
    srNo: 1,
    name: "Ms. Sandhya Dewan",
    designation: "Principal",
    qualification: "M.A (English) B.Ed, M.Ed",
  },
  {
    srNo: 2,
    name: "Ms Upasana Rishiraj",
    designation: "Vice Principal",
    qualification: "MBA, M.A (Eng), B.Ed, UGC",
  },
  {
    srNo: 3,
    name: "Ms Manisha",
    designation: "Coordinator",
    qualification: "M.Sc (CS)/B.Ed (Pursuing)",
  },
  {
    srNo: 4,
    name: "Ms Babita",
    designation: "Teacher",
    qualification: "M.A (Fine Art), B.Ed",
  },
  {
    srNo: 5,
    name: "Ms Deepti",
    designation: "Teacher",
    qualification: "M.Phill (Music)",
  },
  {
    srNo: 6,
    name: "Ms Meena",
    designation: "Teacher",
    qualification: "M.Com, M.A (Sociology)",
  },
  {
    srNo: 7,
    name: "Ms. Bharti",
    designation: "Teacher",
    qualification: "M.A (Hindi), B.Ed, CTET",
  },
  {
    srNo: 8,
    name: "Mr Bhupendra Singh",
    designation: "Teacher",
    qualification: "BBA, PGDM",
  },
  {
    srNo: 9,
    name: "Mr Harpreet Singh",
    designation: "Teacher",
    qualification: "M.Com, B.Ed",
  },
  {
    srNo: 10,
    name: "Ms Sarita Saini",
    designation: "Teacher",
    qualification: "M.Com, MBA, PSTET",
  },
  {
    srNo: 11,
    name: "Ms Nidhi Sood",
    designation: "Teacher",
    qualification: "M.Sc (Chemistry), B.Ed, CTET",
  },
  {
    srNo: 12,
    name: "Ms Manjeet Jakhu",
    designation: "Teacher",
    qualification: "M.A (Pol-Sci), B.Ed, PSTET",
  },
  {
    srNo: 13,
    name: "Ms Rajwinder Kaur",
    designation: "Coordinator",
    qualification: "B.A, B.Ed, M.A (Punjabi) Pursuing",
  },
  {
    srNo: 14,
    name: "Ms Baby Ravinder Kaur",
    designation: "Teacher",
    qualification: "M.A (English), B.Ed",
  },
  {
    srNo: 15,
    name: "Ms Sukhpreet Kaur",
    designation: "Teacher",
    qualification: "M.Sc (Zology), B.Ed, CTET, PSTET",
  },
  {
    srNo: 16,
    name: "Mr Chetan",
    designation: "Teacher",
    qualification: "M.Sc (Physics), B.Ed, CTET",
  },
  {
    srNo: 17,
    name: "Ms Sonika",
    designation: "Teacher",
    qualification: "M.Sc (Biology), B.Ed",
  },
  {
    srNo: 18,
    name: "Ms Shabnam",
    designation: "Teacher",
    qualification: "M.A (Sociology), B.Ed, CTET, PSTET",
  },
  {
    srNo: 19,
    name: "Ms Anamika",
    designation: "Coordinator",
    qualification: "M.Sc (Zology), B.Ed, CTET, PSTET",
  },
  {
    srNo: 20,
    name: "Ms Jatinder Kaur",
    designation: "French Teacher",
    qualification: "B.A, M.A Music Instrumental, Diploma in French",
  },
  {
    srNo: 21,
    name: "Ms Ramandeep Kaur",
    designation: "Teacher",
    qualification: "M.A (Eng), B.Ed",
  },
  {
    srNo: 22,
    name: "Ms. Pooja",
    designation: "Teacher",
    qualification: "M.A (Hindi), B.Ed",
  },
  {
    srNo: 23,
    name: "Ms Nidhi Sood",
    designation: "Teacher",
    qualification: "M.Sc (Chemistry), B.Ed, M.Ed, CTET, PSTET",
  },
  {
    srNo: 24,
    name: "Ms Amritpal Kaur",
    designation: "Teacher",
    qualification: "M.A Punjabi, M.A (Pol-Sc), B.Ed",
  },
  {
    srNo: 25,
    name: "Mr Akshay",
    designation: "Teacher",
    qualification: "M.Sc (Mathematics), B.Ed, PSTET, CTET",
  },
  {
    srNo: 26,
    name: "Ms Ritu",
    designation: "Teacher",
    qualification: "M.Sc (Chemistry), B.Ed, CTET",
  },
  {
    srNo: 27,
    name: "Ms. Namrta",
    designation: "Teacher",
    qualification: "M.Sc (Mathematics)/B.ED",
  },
  {
    srNo: 28,
    name: "Ms Arushi",
    designation: "Teacher",
    qualification: "B Pharmacy",
  },
  {
    srNo: 29,
    name: "Ms Kuljeet Kaur",
    designation: "Coordinator",
    qualification: "M.Sc (Mobile and Distributed Computer Networks)",
  },
  {
    srNo: 30,
    name: "Mr.Kushan",
    designation: "Teacher",
    qualification: "M.Sc (CS)",
  },
  {
    srNo: 31,
    name: "Ms. Sapna",
    designation: "Teacher",
    qualification: "B.A (B.Ed), CTET",
  },
  {
    srNo: 32,
    name: "Ms. Priya Kalia",
    designation: "Teacher",
    qualification: "B.Sc, B.Ed",
  },
  {
    srNo: 33,
    name: "Ms Satinder Kaur",
    designation: "Teacher",
    qualification: "M.A (Punjabi), B.Ed",
  },
  {
    srNo: 34,
    name: "Ms Rupali",
    designation: "Teacher",
    qualification: "M.Sc (IT)",
  },
  {
    srNo: 35,
    name: "Ms Roopkanwal",
    designation: "Teacher",
    qualification: "B.A, B.Ed",
  },
  {
    srNo: 36,
    name: "Ms Megha Panth",
    designation: "Teacher",
    qualification: "B.Sc, M.Sc (Botany)",
  },
  {
    srNo: 37,
    name: "Ms Divya",
    designation: "Teacher",
    qualification: "M.Sc (CS)",
  },
  {
    srNo: 38,
    name: "Ms Harpreet",
    designation: "Teacher",
    qualification: "B.A",
  },
  {
    srNo: 39,
    name: "Ms Salma",
    designation: "Teacher",
    qualification: "M.Sc (Chemistry)",
  },
  {
    srNo: 40,
    name: "Ms. Bhavjeet Kaur",
    designation: "Coordinator",
    qualification: "M.A (Punjabi, Pol-Science), B.Ed",
  },
  {
    srNo: 41,
    name: "Ms Shalini Sood",
    designation: "Teacher",
    qualification: "M.A (English)",
  },
  {
    srNo: 42,
    name: "Ms. Mansi",
    designation: "Teacher",
    qualification: "M.Sc (Chemistry), B.Ed",
  },
  {
    srNo: 43,
    name: "Ms Simran Gabba",
    designation: "Teacher",
    qualification: "BS.C, B.Ed",
  },
  {
    srNo: 44,
    name: "Ms. Mukta Gupta",
    designation: "Teacher",
    qualification: "M.Com, B.Ed",
  },
  {
    srNo: 45,
    name: "Ms Deepti Nijwan",
    designation: "Teacher",
    qualification: "M.Sc (IT) Forensic",
  },
  {
    srNo: 46,
    name: "Ms.Rekha Sharma",
    designation: "Coordinator",
    qualification: "B.Com, N.T.T",
  },
  {
    srNo: 47,
    name: "Ms. Neha Nagpal",
    designation: "Teacher",
    qualification: "MCA, N.T.T",
  },
  {
    srNo: 48,
    name: "Ms Amarpreet",
    designation: "Techer",
    qualification: "B.Com",
  },
  {
    srNo: 49,
    name: "Ms Goldy",
    designation: "Teacher",
    qualification: "B.A, N.T.T",
  },
  {
    srNo: 50,
    name: "Ms Palka",
    designation: "Teacher",
    qualification: "MCA",
  },
  {
    srNo: 51,
    name: "Ms Tanushka",
    designation: "Teacher",
    qualification: "B.Sc, NTT, B.Ed (Pursuing)",
  },
  {
    srNo: 52,
    name: "Ms Ranjeet Kaur",
    designation: "Teacher",
    qualification: "B.A, N.T.T",
  },
  {
    srNo: 53,
    name: "Ms Twinkle",
    designation: "Asst. Teacher",
    qualification: "XII, NTT, B.A (Pursuing)",
  },
  {
    srNo: 54,
    name: "Ms Poonam",
    designation: "Asst. Teacher",
    qualification: "B.A, N.T.T",
  },
  {
    srNo: 55,
    name: "Ms Saroj",
    designation: "Asst. Teacher",
    qualification: "B.A, B.Ed (Pursuing)",
  },
  {
    srNo: 56,
    name: "Ms Mandeep",
    designation: "Asst. Teacher",
    qualification: "XII, NTT",
  },
  {
    srNo: 57,
    name: "Ms Vishakha",
    designation: "Asst. Teacher",
    qualification: "B.A",
  },
  {
    srNo: 58,
    name: "Ms Meenu",
    designation: "Library Teacher",
    qualification: "M.A (Pol-Science), M.LIS",
  },
  {
    srNo: 59,
    name: "Mr Rajesh Sharma",
    designation: "Cricket Coach",
    qualification: "D.P.E.D",
  },
  {
    srNo: 60,
    name: "Mr Abhishek",
    designation: "Volleyball Coach Teacher",
    qualification: "M.PEd",
  },
  {
    srNo: 61,
    name: "Ms Jyoti",
    designation: "Teacher",
    qualification: "B.PEd",
  },
  {
    srNo: 62,
    name: "Ashish Yadav",
    designation: "Teacher",
    qualification: "Basketball Coach",
  },
  {
    srNo: 63,
    name: "Avani Sharma",
    designation: "Teacher",
    qualification: "Judo Coach",
  },
  {
    srNo: 64,
    name: "Simran",
    designation: "Teacher",
    qualification: "Judo Coach",
  },
  {
    srNo: 65,
    name: "Ms Pooja",
    designation: "Teacher",
    qualification: "Swimming Coach",
  },
  {
    srNo: 66,
    name: "Mr Vinod",
    designation: "Instrument Teacher",
    qualification: "B.A",
  },
  {
    srNo: 67,
    name: "Mr Gourav",
    designation: "Dance Teacher",
    qualification: "Choreographer, AIMS Dance Studio",
  },
];

/* =========================================================
   CLASS X
========================================================= */

const classX = [
  {
    year: "2025-26",
    registered: "41",
    passed: "41",
    percentage: "100%",
    remarks:
      "All 41 candidates registered in Class X passed successfully with excellent results.",
  },
];

/* =========================================================
   CLASS XII
========================================================= */

const classXII = [
  {
    year: "2025-26",
    registered: "65",
    passed: "65",
    percentage: "100%",
    remarks:
      "All 65 candidates registered in Class XII passed successfully with excellent results.",
  },
];

/* =========================================================
   INFRASTRUCTURE
========================================================= */

const infrastructure = [
  {
    title: "Total Campus Area (Sq. Mtr.)",
    value: "8739",
  },
  {
    title: "No. & Size of Class Rooms",
    value: "38 Rooms (19000 Sq. Ft.)",
  },
  {
    title: "No. & Size of Laboratories",
    value: "4 Labs (2975 Sq. Ft.)",
  },
  {
    title: "Internet Facility",
    value: "YES",
  },
  {
    title: "No. of Girls Toilets",
    value: "20",
  },
  {
    title: "No. of Boys Toilets",
    value: "13",
  },
];

/* =========================================================
   MOBILE INFORMATION CARD
========================================================= */

function MobileInfoCard({ number, title, value }) {
  return (
    <div
      className="
        w-full
        min-w-0
        bg-white
        rounded-2xl
        border
        border-gray-100
        shadow-md
        p-5
      "
    >
      <div className="flex items-start gap-4">

        <div
          className="
            flex-shrink-0
            w-9
            h-9
            rounded-full
            bg-[#07294d]
            text-white
            flex
            items-center
            justify-center
            font-bold
            text-sm
          "
        >
          {number}
        </div>

        <div className="flex-1 min-w-0">

          <p
            className="
              text-[10px]
              uppercase
              tracking-[1.5px]
              text-[#d4af37]
              font-bold
              mb-1
            "
          >
            Information
          </p>

          <h3
            className="
              text-base
              sm:text-lg
              font-bold
              text-[#07294d]
              leading-6
              break-words
            "
          >
            {title}
          </h3>

        </div>
      </div>

      <div
        className="
          mt-4
          ml-[52px]
          pt-4
          border-t
          border-gray-100
        "
      >

        <p
          className="
            text-[10px]
            uppercase
            tracking-[1.5px]
            text-gray-400
            font-semibold
            mb-1
          "
        >
          Details
        </p>

        <p
          className="
            text-sm
            sm:text-base
            text-gray-700
            leading-6
            break-words
            whitespace-normal
          "
        >
          {value}
        </p>

      </div>
    </div>
  );
}

/* =========================================================
   MOBILE RESULT CARD
========================================================= */

function MobileResultCard({ item }) {
  return (
    <div
      className="
        w-full
        bg-white
        rounded-2xl
        border
        border-gray-100
        shadow-md
        p-5
      "
    >

      <div className="grid grid-cols-2 gap-5">

        <div>
          <p className="text-[10px] uppercase tracking-wide text-gray-400 font-bold">
            Year
          </p>

          <p className="text-base font-bold text-[#07294d] mt-1">
            {item.year}
          </p>
        </div>

        <div>
          <p className="text-[10px] uppercase tracking-wide text-gray-400 font-bold">
            Registered
          </p>

          <p className="text-base font-bold text-[#07294d] mt-1">
            {item.registered}
          </p>
        </div>

        <div>
          <p className="text-[10px] uppercase tracking-wide text-gray-400 font-bold">
            Passed
          </p>

          <p className="text-base font-bold text-[#07294d] mt-1">
            {item.passed}
          </p>
        </div>

        <div>
          <p className="text-[10px] uppercase tracking-wide text-gray-400 font-bold">
            Pass %
          </p>

          <p className="text-base font-bold text-green-600 mt-1">
            {item.percentage}
          </p>
        </div>

      </div>

      <div className="mt-5 pt-4 border-t border-gray-100">

        <p className="text-[10px] uppercase tracking-wide text-gray-400 font-bold">
          Remarks
        </p>

        <p className="text-sm text-gray-600 leading-6 mt-1 break-words">
          {item.remarks}
        </p>

      </div>

    </div>
  );
}

/* =========================================================
   MAIN COMPONENT
========================================================= */

export default function PublicDisclosure() {

  /* =======================================================
     HIDE FLOATING CONTACT / WHATSAPP ON MOBILE
     ONLY WHILE THIS PAGE IS OPEN
  ======================================================= */

  useEffect(() => {

    const originalDisplay = new Map();

    const hideFloatingButtons = () => {

      if (window.innerWidth > 767) return;

      const elements = document.querySelectorAll(
        "a, button, div"
      );

      elements.forEach((element) => {

        const text = (element.textContent || "")
          .trim()
          .toLowerCase();

        const href = (
          element.getAttribute("href") || ""
        ).toLowerCase();

        const style = window.getComputedStyle(element);

        const isFixed =
          style.position === "fixed" ||
          style.position === "sticky";

        const isContact =
          text.includes("contact us");

        const isWhatsApp =
          href.includes("wa.me") ||
          href.includes("whatsapp") ||
          text.includes("whatsapp");

        if (
          isFixed &&
          (isContact || isWhatsApp)
        ) {
          if (!originalDisplay.has(element)) {
            originalDisplay.set(
              element,
              element.style.display
            );
          }

          element.style.display = "none";
        }
      });
    };

    hideFloatingButtons();

    window.addEventListener(
      "resize",
      hideFloatingButtons
    );

    const observer = new MutationObserver(() => {
      hideFloatingButtons();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {

      window.removeEventListener(
        "resize",
        hideFloatingButtons
      );

      observer.disconnect();

      originalDisplay.forEach(
        (display, element) => {
          element.style.display = display;
        }
      );

    };

  }, []);

  return (
    <div className="w-full max-w-full overflow-x-hidden">

      {/* =====================================================
          HERO
      ====================================================== */}

      <section
        className="
          relative
          h-[50vh]
          min-h-[350px]
          sm:h-[55vh]
          md:h-[50vh]
          bg-cover
          bg-center
        "
        style={{
          backgroundImage: `url(${heroImg})`,
        }}
      >

        <div className="absolute inset-0 bg-[#07294d]/80"></div>

        <div
          className="
            relative
            z-10
            h-full
            flex
            flex-col
            justify-center
            items-center
            text-center
            px-4
          "
        >

          <motion.h1
            initial={{
              opacity: 0,
              y: 40,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              duration: 0.6,
            }}
            className="
              text-white
              text-3xl
              sm:text-4xl
              md:text-5xl
              lg:text-6xl
              font-black
              leading-tight
            "
          >
            Public Disclosure
          </motion.h1>

          <motion.p
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            transition={{
              delay: 0.2,
            }}
            className="
              text-white/90
              mt-4
              text-sm
              sm:text-base
              md:text-lg
              leading-6
              max-w-[95%]
            "
          >
            Mandatory Public Disclosure (Appendix - IX)
          </motion.p>

        </div>
      </section>

      {/* =====================================================
          GENERAL INFORMATION
      ====================================================== */}

      <section
        className="
          py-12
          sm:py-16
          md:py-20
          bg-[#f7f9fc]
        "
      >

        <div
          className="
            max-w-7xl
            mx-auto
            px-4
            sm:px-6
          "
        >

          <div
            className="
              text-center
              mb-8
              sm:mb-10
              md:mb-14
            "
          >

            <p
              className="
                uppercase
                tracking-[4px]
                sm:tracking-[7px]
                text-[#d4af37]
                font-bold
                text-xs
                sm:text-sm
              "
            >
              Appendix IX
            </p>

            <h2
              className="
                text-3xl
                sm:text-4xl
                md:text-5xl
                font-black
                text-[#07294d]
                mt-2
                sm:mt-3
                leading-tight
              "
            >
              General Information
            </h2>

          </div>

          {/* DESKTOP TABLE */}

          <div
            className="
              hidden
              md:block
              overflow-hidden
              rounded-3xl
              bg-white
              shadow-xl
              border
              border-gray-100
            "
          >

            <table className="w-full table-fixed">

              <thead className="bg-[#07294d] text-white">

                <tr>

                  <th className="p-5 w-20 text-left">
                    S.No.
                  </th>

                  <th className="p-5 w-[35%] text-left">
                    Information
                  </th>

                  <th className="p-5 text-left">
                    Details
                  </th>

                </tr>

              </thead>

              <tbody>

                {generalInfo.map(
                  (item, index) => (

                    <tr
                      key={index}
                      className="
                        border-b
                        last:border-0
                        hover:bg-[#f8fafc]
                      "
                    >

                      <td
                        className="
                          p-5
                          font-bold
                          text-[#07294d]
                          align-top
                        "
                      >
                        {index + 1}
                      </td>

                      <td
                        className="
                          p-5
                          font-semibold
                          align-top
                          break-words
                        "
                      >
                        {item.title}
                      </td>

                      <td
                        className="
                          p-5
                          text-gray-600
                          align-top
                          break-words
                          whitespace-normal
                        "
                      >
                        {item.value}
                      </td>

                    </tr>

                  )
                )}

              </tbody>

            </table>

          </div>

          {/* MOBILE CARDS */}

          <div className="md:hidden space-y-4">

            {generalInfo.map(
              (item, index) => (

                <MobileInfoCard
                  key={index}
                  number={index + 1}
                  title={item.title}
                  value={item.value}
                />

              )
            )}

          </div>

        </div>
      </section>

      {/* =====================================================
          DOCUMENTS
      ====================================================== */}

      <section
        className="
          py-12
          sm:py-16
          md:py-20
          bg-white
        "
      >

        <div
          className="
            max-w-7xl
            mx-auto
            px-4
            sm:px-6
          "
        >

          <div
            className="
              text-center
              mb-8
              sm:mb-10
              md:mb-14
            "
          >

            <p
              className="
                uppercase
                tracking-[4px]
                sm:tracking-[7px]
                text-[#d4af37]
                font-bold
                text-xs
                sm:text-sm
              "
            >
              Mandatory Disclosure
            </p>

            <h2
              className="
                text-3xl
                sm:text-4xl
                md:text-5xl
                font-black
                text-[#07294d]
                mt-2
                sm:mt-3
                leading-tight
              "
            >
              Documents & Information
            </h2>

            <p
              className="
                text-gray-500
                mt-3
                sm:mt-4
                text-sm
                sm:text-base
              "
            >
              Click any document below to open the official PDF.
            </p>

          </div>

          <div
            className="
              grid
              grid-cols-1
              sm:grid-cols-2
              xl:grid-cols-3
              gap-5
              sm:gap-7
              md:gap-8
            "
          >

            {documents.map(
              (item, index) => (

                <motion.a
                  key={index}
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"

                  initial={{
                    opacity: 0,
                    y: 40,
                  }}

                  whileInView={{
                    opacity: 1,
                    y: 0,
                  }}

                  transition={{
                    duration: 0.5,
                    delay: index * 0.08,
                  }}

                  viewport={{
                    once: true,
                  }}

                  whileHover={{
                    y: -6,
                    scale: 1.01,
                  }}

                  className="
                    group
                    bg-[#f7f9fc]
                    rounded-2xl
                    sm:rounded-3xl
                    p-5
                    sm:p-7
                    border
                    border-gray-100
                    shadow-lg
                    hover:shadow-xl
                    hover:border-[#d4af37]
                    transition-all
                    duration-300
                    w-full
                    min-w-0
                  "
                >

                  <div
                    className="
                      w-14
                      h-14
                      sm:w-16
                      sm:h-16
                      rounded-xl
                      sm:rounded-2xl
                      bg-[#07294d]
                      text-[#d4af37]
                      flex
                      items-center
                      justify-center
                      text-2xl
                      sm:text-3xl
                      mb-5
                      sm:mb-6
                      group-hover:bg-[#d4af37]
                      group-hover:text-[#07294d]
                      transition
                    "
                  >
                    <FaFilePdf />
                  </div>

                  <h3
                    className="
                      text-lg
                      sm:text-xl
                      font-bold
                      text-[#07294d]
                      leading-7
                      sm:leading-8
                      break-words
                    "
                  >
                    {item.title}
                  </h3>

                  <div
                    className="
                      flex
                      items-center
                      justify-between
                      gap-4
                      mt-6
                      sm:mt-8
                    "
                  >

                    <span
                      className="
                        font-semibold
                        text-[#d4af37]
                        text-sm
                        sm:text-base
                      "
                    >
                      View PDF
                    </span>

                    <FaArrowRight
                      className="
                        flex-shrink-0
                        text-[#07294d]
                        group-hover:translate-x-2
                        transition-transform
                      "
                    />

                  </div>

                </motion.a>

              )
            )}

          </div>

        </div>
      </section>

      {/* =====================================================
          RESULT & ACADEMICS
      ====================================================== */}

      <section
        className="
          py-12
          sm:py-16
          md:py-20
          bg-[#f7f9fc]
        "
      >

        <div
          className="
            max-w-7xl
            mx-auto
            px-4
            sm:px-6
          "
        >

          <div
            className="
              text-center
              mb-8
              sm:mb-10
              md:mb-14
            "
          >

            <p
              className="
                uppercase
                tracking-[4px]
                sm:tracking-[7px]
                text-[#d4af37]
                font-bold
                text-xs
                sm:text-sm
              "
            >
              Academic Information
            </p>

            <h2
              className="
                text-3xl
                sm:text-4xl
                md:text-5xl
                font-black
                text-[#07294d]
                mt-2
                sm:mt-3
                leading-tight
              "
            >
              Result & Academics
            </h2>

            <p
              className="
                text-gray-500
                mt-3
                sm:mt-4
                text-sm
                sm:text-base
              "
            >
              Academic records and mandatory school documents.
            </p>

          </div>

          <div
            className="
              grid
              grid-cols-1
              sm:grid-cols-2
              xl:grid-cols-3
              gap-5
              sm:gap-7
              md:gap-8
            "
          >

            {academics.map(
              (item, index) => (

                <motion.a
                  key={index}
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"

                  initial={{
                    opacity: 0,
                    y: 40,
                  }}

                  whileInView={{
                    opacity: 1,
                    y: 0,
                  }}

                  transition={{
                    duration: 0.5,
                    delay: index * 0.08,
                  }}

                  viewport={{
                    once: true,
                  }}

                  whileHover={{
                    y: -6,
                    scale: 1.01,
                  }}

                  className="
                    group
                    bg-white
                    rounded-2xl
                    sm:rounded-3xl
                    p-5
                    sm:p-7
                    border
                    border-gray-100
                    shadow-lg
                    hover:border-[#d4af37]
                    hover:shadow-xl
                    transition-all
                    duration-300
                    w-full
                    min-w-0
                  "
                >

                  <div
                    className="
                      w-14
                      h-14
                      sm:w-16
                      sm:h-16
                      rounded-xl
                      sm:rounded-2xl
                      bg-[#07294d]
                      text-[#d4af37]
                      flex
                      items-center
                      justify-center
                      text-2xl
                      sm:text-3xl
                      mb-5
                      sm:mb-6
                      group-hover:bg-[#d4af37]
                      group-hover:text-[#07294d]
                      transition
                    "
                  >
                    <FaFilePdf />
                  </div>

                  <h3
                    className="
                      text-lg
                      sm:text-xl
                      font-bold
                      text-[#07294d]
                      leading-7
                      sm:leading-8
                      break-words
                    "
                  >
                    {item.title}
                  </h3>

                  <div
                    className="
                      flex
                      items-center
                      justify-between
                      gap-4
                      mt-6
                      sm:mt-8
                    "
                  >

                    <span
                      className="
                        text-[#d4af37]
                        font-semibold
                        text-sm
                        sm:text-base
                      "
                    >
                      Open PDF
                    </span>

                    <FaArrowRight
                      className="
                        flex-shrink-0
                        text-[#07294d]
                        group-hover:translate-x-2
                        transition-transform
                      "
                    />

                  </div>

                </motion.a>

              )
            )}

          </div>

        </div>
      </section>

      {/* =====================================================
          STAFF
      ====================================================== */}

  {/* ================= STAFF DETAILS ================= */}
{/* ================= STAFF DETAILS ================= */}
<section className="py-20 bg-white">
  <div className="max-w-7xl mx-auto px-4 sm:px-6">

    {/* Heading */}
    <div className="text-center mb-10 md:mb-14">
      <p className="uppercase tracking-[4px] md:tracking-[7px] text-[#d4af37] font-bold text-sm md:text-base">
        Teaching Staff
      </p>

      <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-[#07294d] mt-3">
        Staff Details
      </h2>

      <p className="text-gray-500 mt-3 text-sm md:text-base">
        Cambridge International School, Nakodar
      </p>
    </div>

    {/* ================= DESKTOP TABLE ================= */}
    <div className="hidden md:block overflow-hidden rounded-3xl bg-white shadow-xl border border-gray-200">

      <table className="w-full border-collapse">

        <thead className="bg-[#07294d] text-white">
          <tr>
            <th className="p-4 text-left border-r border-white/20 w-24">
              Sr. No.
            </th>

            <th className="p-4 text-left border-r border-white/20">
              Name
            </th>

            <th className="p-4 text-left border-r border-white/20">
              Designation
            </th>

            <th className="p-4 text-left">
              Professional Qualification
            </th>
          </tr>
        </thead>

        <tbody>
          {staff.map((item) => (
            <tr
              key={item.srNo}
              className="border-b border-gray-200 hover:bg-[#f8fafc] transition-colors"
            >
              <td className="p-4 font-bold text-[#07294d] border-r border-gray-200">
                {item.srNo}
              </td>

              <td className="p-4 font-medium text-gray-800 border-r border-gray-200">
                {item.name}
              </td>

              <td
                className={`p-4 border-r border-gray-200 ${
                  item.designation === "Coordinator"
                    ? "font-bold text-[#07294d]"
                    : "text-gray-700"
                }`}
              >
                {item.designation}
              </td>

              <td className="p-4 text-gray-700 leading-6">
                {item.qualification}
              </td>
            </tr>
          ))}
        </tbody>

      </table>
    </div>


    {/* ================= MOBILE STAFF CARDS ================= */}
    <div className="md:hidden space-y-4">

      {staff.map((item) => (
        <div
          key={item.srNo}
          className="bg-white rounded-2xl border border-gray-200 shadow-md overflow-hidden"
        >

          {/* Top bar */}
          <div className="bg-[#07294d] text-white px-4 py-3 flex items-center justify-between">

            <span className="text-sm font-bold">
              Sr. No. {item.srNo}
            </span>

            <span className="text-xs bg-white/10 px-3 py-1 rounded-full">
              Staff
            </span>

          </div>


          {/* Details */}
          <div className="p-4 space-y-3">

            <div>
              <p className="text-xs uppercase tracking-wider text-gray-400 font-semibold">
                Name
              </p>

              <p className="text-base font-bold text-[#07294d] mt-1 break-words">
                {item.name}
              </p>
            </div>


            <div>
              <p className="text-xs uppercase tracking-wider text-gray-400 font-semibold">
                Designation
              </p>

              <p
                className={`text-sm mt-1 break-words ${
                  item.designation === "Coordinator"
                    ? "font-bold text-[#07294d]"
                    : "text-gray-700"
                }`}
              >
                {item.designation}
              </p>
            </div>


            <div>
              <p className="text-xs uppercase tracking-wider text-gray-400 font-semibold">
                Professional Qualification
              </p>

              <p className="text-sm text-gray-700 leading-6 mt-1 break-words">
                {item.qualification}
              </p>
            </div>

          </div>
        </div>
      ))}

    </div>

  </div>
</section>

      {/* =====================================================
          CLASS X RESULT
      ====================================================== */}

      <section
        className="
          py-12
          sm:py-16
          md:py-20
          bg-[#f7f9fc]
        "
      >

        <div
          className="
            max-w-7xl
            mx-auto
            px-4
            sm:px-6
          "
        >

          <h2
            className="
              text-center
              text-3xl
              sm:text-4xl
              md:text-5xl
              font-black
              text-[#07294d]
              mb-8
              sm:mb-10
              md:mb-12
            "
          >
            Result - Class X
          </h2>

          {/* DESKTOP */}

          <div
            className="
              hidden
              md:block
              overflow-hidden
              rounded-3xl
              bg-white
              shadow-xl
            "
          >

            <table className="w-full table-fixed">

              <thead className="bg-[#07294d] text-white">

                <tr>

                  <th className="p-5 w-28">
                    Year
                  </th>

                  <th className="p-5 w-32">
                    Registered
                  </th>

                  <th className="p-5 w-28">
                    Passed
                  </th>

                  <th className="p-5 w-28">
                    Pass %
                  </th>

                  <th className="p-5 text-left">
                    Remarks
                  </th>

                </tr>

              </thead>

              <tbody>

                {classX.map(
                  (item, index) => (

                    <tr
                      key={index}
                      className="
                        text-center
                        border-b
                      "
                    >

                      <td className="p-5">
                        {item.year}
                      </td>

                      <td className="p-5">
                        {item.registered}
                      </td>

                      <td className="p-5">
                        {item.passed}
                      </td>

                      <td
                        className="
                          p-5
                          font-bold
                          text-green-600
                        "
                      >
                        {item.percentage}
                      </td>

                      <td
                        className="
                          p-5
                          text-left
                          break-words
                        "
                      >
                        {item.remarks}
                      </td>

                    </tr>

                  )
                )}

              </tbody>

            </table>

          </div>

          {/* MOBILE */}

          <div className="md:hidden space-y-4">

            {classX.map(
              (item, index) => (

                <MobileResultCard
                  key={index}
                  item={item}
                />

              )
            )}

          </div>

        </div>
      </section>

      {/* =====================================================
          CLASS XII RESULT
      ====================================================== */}

      <section
        className="
          py-12
          sm:py-16
          md:py-20
          bg-white
        "
      >

        <div
          className="
            max-w-7xl
            mx-auto
            px-4
            sm:px-6
          "
        >

          <h2
            className="
              text-center
              text-3xl
              sm:text-4xl
              md:text-5xl
              font-black
              text-[#07294d]
              mb-8
              sm:mb-10
              md:mb-12
            "
          >
            Result - Class XII
          </h2>

          {/* DESKTOP */}

          <div
            className="
              hidden
              md:block
              overflow-hidden
              rounded-3xl
              bg-white
              shadow-xl
            "
          >

            <table className="w-full table-fixed">

              <thead className="bg-[#07294d] text-white">

                <tr>

                  <th className="p-5 w-28">
                    Year
                  </th>

                  <th className="p-5 w-32">
                    Registered
                  </th>

                  <th className="p-5 w-28">
                    Passed
                  </th>

                  <th className="p-5 w-28">
                    Pass %
                  </th>

                  <th className="p-5 text-left">
                    Remarks
                  </th>

                </tr>

              </thead>

              <tbody>

                {classXII.map(
                  (item, index) => (

                    <tr
                      key={index}
                      className="
                        text-center
                        border-b
                      "
                    >

                      <td className="p-5">
                        {item.year}
                      </td>

                      <td className="p-5">
                        {item.registered}
                      </td>

                      <td className="p-5">
                        {item.passed}
                      </td>

                      <td
                        className="
                          p-5
                          font-bold
                          text-green-600
                        "
                      >
                        {item.percentage}
                      </td>

                      <td
                        className="
                          p-5
                          text-left
                          break-words
                        "
                      >
                        {item.remarks}
                      </td>

                    </tr>

                  )
                )}

              </tbody>

            </table>

          </div>

          {/* MOBILE */}

          <div className="md:hidden space-y-4">

            {classXII.map(
              (item, index) => (

                <MobileResultCard
                  key={index}
                  item={item}
                />

              )
            )}

          </div>

        </div>
      </section>

      {/* =====================================================
          SCHOOL INFRASTRUCTURE
      ====================================================== */}

      <section
        className="
          py-12
          sm:py-16
          md:py-20
          bg-[#f7f9fc]
        "
      >

        <div
          className="
            max-w-7xl
            mx-auto
            px-4
            sm:px-6
          "
        >

          <div
            className="
              text-center
              mb-8
              sm:mb-10
              md:mb-14
            "
          >

            <p
              className="
                uppercase
                tracking-[4px]
                sm:tracking-[7px]
                text-[#d4af37]
                font-bold
                text-xs
                sm:text-sm
              "
            >
              Campus Details
            </p>

            <h2
              className="
                text-3xl
                sm:text-4xl
                md:text-5xl
                font-black
                text-[#07294d]
                mt-2
                sm:mt-3
              "
            >
              School Infrastructure
            </h2>

          </div>

          {/* DESKTOP */}

          <div
            className="
              hidden
              md:block
              overflow-hidden
              rounded-3xl
              bg-white
              shadow-xl
              border
              border-gray-100
            "
          >

            <table className="w-full table-fixed">

              <thead className="bg-[#07294d] text-white">

                <tr>

                  <th className="p-5 text-left w-20">
                    S.No.
                  </th>

                  <th className="p-5 text-left">
                    Information
                  </th>

                  <th className="p-5 text-left">
                    Details
                  </th>

                </tr>

              </thead>

              <tbody>

                {infrastructure.map(
                  (item, index) => (

                    <tr
                      key={index}
                      className="
                        border-b
                        hover:bg-[#f8fafc]
                      "
                    >

                      <td
                        className="
                          p-5
                          font-bold
                          text-[#07294d]
                        "
                      >
                        {index + 1}
                      </td>

                      <td
                        className="
                          p-5
                          font-semibold
                          break-words
                        "
                      >
                        {item.title}
                      </td>

                      <td
                        className="
                          p-5
                          text-gray-600
                          break-words
                        "
                      >
                        {item.value}
                      </td>

                    </tr>

                  )
                )}

                <tr>

                  <td
                    className="
                      p-5
                      font-bold
                      text-[#07294d]
                    "
                  >
                    7
                  </td>

                  <td className="p-5 font-semibold">
                    School Inspection Video
                  </td>

                  <td className="p-5">

                    <a
                      href="https://youtu.be/CsBKSqmlKS4"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="
                        inline-flex
                        items-center
                        gap-3
                        bg-[#07294d]
                        text-white
                        px-6
                        py-3
                        rounded-xl
                        hover:bg-[#0b3d6d]
                        transition
                      "
                    >
                      <FaPlayCircle />
                      Watch on YouTube
                    </a>

                  </td>

                </tr>

              </tbody>

            </table>

          </div>

          {/* MOBILE */}

          <div className="md:hidden space-y-4">

            {infrastructure.map(
              (item, index) => (

                <MobileInfoCard
                  key={index}
                  number={index + 1}
                  title={item.title}
                  value={item.value}
                />

              )
            )}

            {/* VIDEO */}

            <div
              className="
                w-full
                bg-white
                rounded-2xl
                border
                border-gray-100
                shadow-md
                p-5
              "
            >

              <div className="flex items-start gap-4">

                <div
                  className="
                    flex-shrink-0
                    w-9
                    h-9
                    rounded-full
                    bg-[#07294d]
                    text-white
                    flex
                    items-center
                    justify-center
                    font-bold
                    text-sm
                  "
                >
                  7
                </div>

                <div className="min-w-0 flex-1">

                  <p
                    className="
                      text-[10px]
                      uppercase
                      tracking-[1.5px]
                      text-[#d4af37]
                      font-bold
                      mb-1
                    "
                  >
                    Information
                  </p>

                  <h3
                    className="
                      text-base
                      font-bold
                      text-[#07294d]
                      break-words
                    "
                  >
                    School Inspection Video
                  </h3>

                </div>

              </div>

              <div className="mt-5 ml-[52px]">

                <a
                  href="https://youtu.be/CsBKSqmlKS4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="
                    inline-flex
                    items-center
                    justify-center
                    gap-2
                    bg-[#07294d]
                    text-white
                    px-4
                    py-3
                    rounded-xl
                    hover:bg-[#0b3d6d]
                    transition
                    text-sm
                    font-semibold
                    w-full
                  "
                >
                  <FaPlayCircle />
                  Watch on YouTube
                </a>

              </div>

            </div>

          </div>

        </div>
      </section>

      {/* =====================================================
          FIRE SAFETY CERTIFICATE
      ====================================================== */}

      <section
        className="
          py-12
          sm:py-16
          md:py-20
          bg-white
        "
      >

        <div
          className="
            max-w-5xl
            mx-auto
            px-4
            sm:px-6
          "
        >

          <div
            className="
              text-center
              mb-8
              sm:mb-10
              md:mb-12
            "
          >

            <p
              className="
                uppercase
                tracking-[4px]
                sm:tracking-[7px]
                text-[#d4af37]
                font-bold
                text-xs
                sm:text-sm
              "
            >
              Additional Document
            </p>

            <h2
              className="
                text-3xl
                sm:text-4xl
                md:text-5xl
                font-black
                text-[#07294d]
                mt-2
                sm:mt-3
                leading-tight
              "
            >
              Fire Safety Certificate
            </h2>

            <p
              className="
                text-gray-500
                mt-3
                sm:mt-4
                text-sm
                sm:text-base
              "
            >
              Click below to view the official Fire Safety Certificate.
            </p>

          </div>

          <motion.a
            href="/firesafety.pdf"
            target="_blank"
            rel="noopener noreferrer"

            whileHover={{
              y: -5,
              scale: 1.01,
            }}

            transition={{
              duration: 0.3,
            }}

            className="
              group
              flex
              flex-col
              md:flex-row
              items-center
              md:items-center
              justify-between
              gap-6
              bg-[#f7f9fc]
              border
              border-gray-100
              rounded-2xl
              sm:rounded-3xl
              p-5
              sm:p-6
              md:p-8
              shadow-lg
              hover:border-[#d4af37]
              hover:shadow-2xl
              transition-all
              duration-300
              text-center
              md:text-left
              w-full
            "
          >

            <div
              className="
                flex
                flex-col
                sm:flex-row
                items-center
                gap-4
                sm:gap-5
                min-w-0
              "
            >

              <div
                className="
                  w-16
                  h-16
                  sm:w-20
                  sm:h-20
                  flex-shrink-0
                  rounded-xl
                  sm:rounded-2xl
                  bg-[#07294d]
                  flex
                  items-center
                  justify-center
                  text-[#d4af37]
                  text-3xl
                  sm:text-4xl
                  group-hover:bg-[#d4af37]
                  group-hover:text-[#07294d]
                  transition
                "
              >
                <FaFilePdf />
              </div>

              <div className="min-w-0">

                <h3
                  className="
                    text-xl
                    sm:text-2xl
                    font-bold
                    text-[#07294d]
                  "
                >
                  Fire Safety Certificate
                </h3>

                <p
                  className="
                    text-gray-600
                    mt-2
                    text-sm
                    sm:text-base
                    leading-6
                  "
                >
                  View the official Fire Safety Certificate issued for the
                  school.
                </p>

              </div>

            </div>

            <div
              className="
                flex
                items-center
                gap-3
                text-[#d4af37]
                font-bold
                text-base
                sm:text-lg
                flex-shrink-0
              "
            >

              View PDF

              <FaArrowRight
                className="
                  group-hover:translate-x-2
                  transition-transform
                "
              />

            </div>

          </motion.a>

        </div>

      </section>

    </div>
  );
}